import { css } from "@emotion/css";
import { LOBBIE_COLORS } from "./colors";

export const regularTextCSS = css({
    fontWeight: 400,
});
export const boldTextCSS = css({
    fontWeight: 700,
});
export const noMarginCSS = css({
    margin: 0,
});
export const secondaryDarkerTextCSS = css({
    color: LOBBIE_COLORS.secondaryDarker,
});
export const secondaryDarkTextCSS = css({
    fontWeight: 500,
    color: LOBBIE_COLORS.secondaryDark,
});
export const transparentTextCSS = css({
    color: "transparent",
});
